import React from 'react';
import './NFTTabTooltip.css';

const NFTTabTooltip = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="nft-tab-tooltip">
      <div className="tooltip-content">
        Click here to see your NFTs
      </div>
      <div className="tooltip-arrow" />
    </div>
  );
};

export default NFTTabTooltip;